import { render, staticRenderFns } from "./HomeTeamTable.vue?vue&type=template&id=99191fe6&scoped=true&"
import script from "./HomeTeamTable.vue?vue&type=script&lang=js&"
export * from "./HomeTeamTable.vue?vue&type=script&lang=js&"
import style0 from "./HomeTeamTable.vue?vue&type=style&index=0&id=99191fe6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99191fe6",
  null
  
)

export default component.exports